import styled from "styled-components";

export const BlogDetailsPageContainer = styled.div.attrs({
  className: "blog-details-page p-6 flex flex-col items-center",
})``;

export const BlogTitle = styled.h1.attrs({
  className: "text-3xl text-center font-semibold mb-4",
})``;

export const BlogDate = styled.p.attrs({
  className: "text-lg text-center text-gray-500 mb-6",
})``;

export const BlogImage = styled.img.attrs({
  className: "w-full h-96 md:w-1/2 mx-auto my-6 rounded-lg shadow-lg",
})``;

export const BlogContent = styled.p.attrs({
  className: "text-xl text-gray-700 text-center mb-6 max-w-screen-md",
})``;

export const ButtonContainer = styled.div.attrs({
  className: "flex justify-center mt-8 gap-4",
})``;

export const Button = styled.button.attrs(({ disabled }) => ({
  className: `px-6 py-3 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition duration-300 ${
    disabled ? "opacity-50 cursor-not-allowed" : ""
  }`,
}))``;
